import { Skeleton } from "antd";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as _ from "lodash";
import { useIsMutating, useQueryClient } from "@tanstack/react-query";

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";

import "@/assets/css/swiper-cards.css";

export const StoresSwiper = ({handleClickTienda}) => {

  const queryClient = useQueryClient();
  const isMutating = useIsMutating({ mutationKey: ["listaEmpresasMutate"] });
  const tiendas = queryClient.getQueryData(["empresas"]);
  

  const TiendasComponent = () => {
    if (_.size(tiendas) > 0) {

      return (
        <>
          <Swiper
            slidesPerView={3}
            spaceBetween={20}
            grabCursor={true}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
            breakpoints={{
              340: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 8,
                spaceBetween: 20,
              },
            }}
          >
            {tiendas.map((item) => (
              <SwiperSlide key={item.empresa_id}>
                <img
                  className="shadow p-2 img-fluid"
                  onClick={() => handleClickTienda(item.empresa_id)}
                  src={item.logo_empresa}
                  alt={item.empresa_nombre}
                  style={{
                    width: "100px", // Ancho predeterminado
                    height: "100px", // Alto predeterminado
                    objectFit: "scale-down", // Ajusta la imagen para cubrir el área establecida
                    borderRadius: "50%",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      );
    }

    return <h4 className="text-center">No se encontraron tiendas</h4>;
  };

  return (
    <Skeleton loading={isMutating}>
            <TiendasComponent />
    </Skeleton>
  );
}